export default __webpack_public_path__ + "static/BlinkFitness_Lean-964e9bd8aa038b26b0a76610b449a4fc.ttf";